export default "__VITE_ASSET__2919254f__"